import dynamic from 'next/dynamic';
import { getSiteStaticProps } from '@/utils/siteStaticProps';

const HomeContent = dynamic(() => import('@/components/SitePages').then(module => module.HomePage), {
  ssr: false,
});

export default function HomePage() {
  return <HomeContent />;
}

export const getStaticProps = getSiteStaticProps({
  seo: { page: 'Actividades' },
});
